import axios from 'axios';

/**
 * Catálogo de compañías (multicompañía) — módulo `lu-company` del backend.
 * Docs: GET /api/v1/lu-company?status=ACTIVE  → arreglo sin paginar.
 *
 * El `companyId` que se envía a odoo/user-clients corresponde al `id` de lu-company;
 * backend se encarga de resolver el odooCompanyId correspondiente.
 */
export const COMPANY_VALUE_KEY = 'id';

/** Compañía por defecto (id de lu-company): los clientes existentes se poblaron con company_id = 1. */
export const DEFAULT_COMPANY_ID = 1;
// Sólo se usa si el catálogo falla o viene vacío; el nombre real lo da lu-company.
const DEFAULT_COMPANY = { id: DEFAULT_COMPANY_ID, odooCompanyId: 1, companyName: `Company ${DEFAULT_COMPANY_ID}`, status: 'ACTIVE' };

let companiesPromise = null;

export const toCompanyOption = (company) => ({
  value: Number(company?.[COMPANY_VALUE_KEY]),
  label: company?.companyName || `Company ${company?.[COMPANY_VALUE_KEY]}`,
  company
});

/**
 * Obtiene las compañías activas (cacheado en memoria por sesión de la app).
 * Si el catálogo viene vacío o falla, regresa la compañía por defecto para no bloquear la operación.
 */
export const fetchActiveCompanies = async (token, { force = false } = {}) => {
  if (!token) return [DEFAULT_COMPANY];
  if (!companiesPromise || force) {
    companiesPromise = axios
      .get(`${process.env.REACT_APP_NESTJS_API}/api/v1/lu-company`, {
        params: { status: 'ACTIVE' },
        headers: { authorization: `Bearer ${token}` }
      })
      .then(({ data }) => {
        const list = Array.isArray(data) ? data : [];
        if (!list.length) {
          console.warn('[lu-company] Catálogo vacío, se usa la compañía por defecto.');
          return [DEFAULT_COMPANY];
        }
        return list;
      })
      .catch((err) => {
        companiesPromise = null; // permitir reintento
        console.error('[lu-company] Error al obtener compañías:', err);
        return [DEFAULT_COMPANY];
      });
  }
  return companiesPromise;
};

/** Normaliza el valor a número entero o null. */
export const parseCompanyId = (value) => {
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? null : n;
};
